import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaUserShield } from "react-icons/fa";

export default function Privacy() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="max-w-4xl w-full mx-auto p-6 bg-white rounded-xl shadow-lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-lg relative"
        >
          <Link
            to="/"
            className="absolute -top-10 left-0 text-yellow-500 hover:text-yellow-600 flex items-center"
          >
            <FaChevronLeft className="mr-1" /> Back to Home
          </Link>

          <div className="flex items-center mb-4">
            <FaUserShield className="text-yellow-500 mr-2 text-xl" />
            <h2 className="text-3xl font-bold text-yellow-600">
              Your Privacy Matters
            </h2>
          </div>

          <div className="space-y-6">
            <div className="border-l-4 border-yellow-500 pl-4">
              <h3 className="text-xl font-semibold">Data Protection</h3>
              <p>
                Your information is handled with the same{" "}
                <span className="font-bold text-yellow-600">
                  discretion and care
                </span>{" "}
                that top international performers expect. Notice how this makes
                you feel more secure about sharing your portfolio.
              </p>
            </div>

            <div className="border-l-4 border-yellow-500 pl-4">
              <h3 className="text-xl font-semibold">Our Promise</h3>
              <p>
                We only share your details with{" "}
                <span className="font-bold text-yellow-600">
                  pre-vetted partners
                </span>
                . As you read this, you're realizing how different we are from
                agencies that spam your information.
              </p>
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
              <p className="italic">
                "That feeling of relief you're experiencing? That's your
                intuition recognizing a partner who truly values your privacy
                and career."
              </p>
            </div>

            <div className="text-center mt-8">
              <Link
                to="/#apply"
                className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-8 rounded-lg transition"
              >
                Apply With Confidence
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
